// extracted by mini-css-extract-plugin
module.exports = {"main":"SectionHeader_main__dB_1G","decorator":"SectionHeader_decorator__COPo8"};